// extracted by css-extract-rspack-plugin
export default {"banner":"Banner_banner__ZZCSY"};